export class Icons {
  constructor(private readonly icons: Object) {}
}
